// Our own icons instead of emojis (spec 2026-09-29-ui-icons-e1-design.md). Strings carry
// {name} tokens; iconText / iconHtml draw them. `replaces` drives tokenize() for the sweep.
export const ICONS = {
  coin: { replaces: ['💰'] }, fuel: { replaces: ['⛽'] }, canister: { replaces: ['🛢'] }, xp_star: { replaces: ['⭐'] },
  seedling: { replaces: ['🌱'] }, wheat: { replaces: ['🌾'] }, basket: { replaces: ['🧺'] }, hoe: { replaces: ['⛏'] }, shovel: { replaces: [] },
  tractor: { replaces: ['🚜'] }, hand: { replaces: ['✋'] }, hourglass: { replaces: ['⏳'] }, timer: { replaces: ['⏱'] },
  crate: { replaces: ['📦'] }, cart: { replaces: ['🛒'] }, house: { replaces: ['🏠'] }, chicken: { replaces: ['🐔'] },
  friends: { replaces: ['👭', '👥'] }, letter: { replaces: ['✉'] }, medal: { replaces: ['🏅'] }, sun: { replaces: ['🌞'] },
  party: { replaces: ['🎉'] }, sparkle: { replaces: ['✨'] }, lock: { replaces: ['🔒'] }, check: { replaces: ['✓', '✔', '✅'] },
  cross: { replaces: ['✕', '✖', '❌'] }, dot_green: { replaces: ['🟢'] }, dot_grey: { replaces: ['⚪'] }, dot_red: { replaces: ['🔴'] },
  star_full: { replaces: ['★', '🌟'] }, star_empty: { replaces: ['☆'] }, plus: { replaces: ['➕'] },
  arrow_right: { replaces: ['→', '▶'] }, arrow_left: { replaces: ['←', '◀'] }, flip: { replaces: ['↻'] },

  // E2 · driving, road signs, arrows
  car: { replaces: ['🚗', '🚙'] },
  truck: { replaces: ['🚚'] },
  bike: { replaces: ['🚲'] },
  wrench: { replaces: ['🔧'] },
  battery: { replaces: ['🔋'] },
  plug: { replaces: ['🔌'] },
  licence: { replaces: ['🪪'] },
  gear: { replaces: ['⚙'] },
  horse: { replaces: ['🐎'] },
  ruler: { replaces: ['📏'] },
  rocket: { replaces: ['🚀'] },
  money_out: { replaces: ['💸'] },
  finish: { replaces: ['🏁'] },
  grad_cap: { replaces: ['🎓'] },
  book: { replaces: ['📖'] },
  note: { replaces: ['📝', '📋'] },
  speak: { replaces: ['🗣'] },
  bulb: { replaces: ['💡'] },
  test_tube: { replaces: ['🧪'] },
  target: { replaces: ['🎯'] },
  gamepad: { replaces: ['🎮'] },
  dot_black: { replaces: ['⚫'] },
  arrow_up: { replaces: ['↑'] },
  arrow_down: { replaces: ['↓'] },
  arrows_lr: { replaces: ['↔'] },
  arrows_ud: { replaces: ['↕'] },
  back: { replaces: ['↩'] },
  repeat: { replaces: ['🔄', '🔁'] },
  sign_speed: { replaces: ['🔢'] },
  sign_lights: { replaces: ['🚦'] },
  sign_no_overtake: { replaces: ['⛔'] },
  sign_lane: { replaces: ['🛣'] },
  sign_no_entry: { replaces: ['🚫'] },
  sign_stop: { replaces: ['🛑'] },       // the three real signs (items/sign_*.webp, pole cropped off)
  sign_yield: { replaces: ['⚠'] },
  sign_crossing: { replaces: ['🚸'] },
  sign_parking: { replaces: ['🅿'] },
  box_empty: { replaces: ['⬜'] },
  // Front-view crop pictures (the Złota tabliczka board, crops inside text) — no emoji replaced.
  crop_rzodkiewka: { replaces: [] },
  crop_salata: { replaces: [] },
  crop_truskawka: { replaces: [] },
  crop_cukinia: { replaces: [] },
  crop_marchewka: { replaces: [] },
  crop_pomidor: { replaces: [] },
  crop_ogorek: { replaces: [] },
  crop_malina: { replaces: [] },
  crop_papryka: { replaces: [] },
  crop_ziemniak: { replaces: [] },
  crop_dynia: { replaces: [] },
  crop_kukurydza: { replaces: [] },
  crop_arbuz: { replaces: [] },
  crop_slonecznik: { replaces: [] },
  crop_zyto: { replaces: [] },
  crop_pszenica: { replaces: [] },
  // E2 · game hall
  dice: { replaces: ['🎲'] },
  trophy: { replaces: ['🏆'] },
  handshake: { replaces: ['🤝'] },
  crown: { replaces: ['👑'] },
  castle: { replaces: ['🏰'] },
  door: { replaces: ['🚪'] },
  eyes: { replaces: ['👀'] },
  robot: { replaces: ['🤖'] },
  face_smile: { replaces: ['🙂'] },
  face_think: { replaces: ['🤔'] },
  face_wow: { replaces: ['😮'] },
  brain: { replaces: ['🧠'] },
  // E2 · house, shops, chat and sound
  yard: { replaces: ['🏡'] },
  dress: { replaces: ['👗'] },
  chair: { replaces: ['🪑'] },
  sofa: { replaces: ['🛋'] },
  bed: { replaces: ['🛏'] },
  plant: { replaces: ['🪴'] },
  pan: { replaces: ['🍳'] },
  ladder: { replaces: ['🪜'] },
  walk: { replaces: ['🚶'] },
  girl: { replaces: ['👧'] },
  boy: { replaces: ['👦'] },
  moon: { replaces: ['🌙'] },
  picture: { replaces: ['🖼'] },
  wifi: { replaces: ['🛜'] },
  clock: { replaces: ['🕑'] },
  palette: { replaces: ['🎨'] },
  paw: { replaces: ['🐾'] },
  egg: { replaces: ['🥚'] },
  cow: { replaces: ['🐮', '🐄'] },
  dog: { replaces: ['🐶'] },
  cat: { replaces: ['🐱'] },
  milk: { replaces: ['🥛'] },
  food: { replaces: ['🍴'] },
  sleep: { replaces: ['😴'] },
  wave: { replaces: ['👋'] },
  heart: { replaces: ['💖'] },
  grin: { replaces: ['😄'] },
  love_eyes: { replaces: ['😍'] },
  thumbs_up: { replaces: ['👍'] },
  chat: { replaces: ['💬'] },
  music: { replaces: ['🎵'] },
  music_off: { replaces: ['🔇'] },
  sound: { replaces: ['🔊'] },
  sound_off: { replaces: ['🔈'] },
  pause: { replaces: ['⏸'] },
};

for (const [name, icon] of Object.entries(ICONS)) icon.key = `icon_${name}`;
export const iconKey = (name) => `icon_${name}`;
export const TOKEN_RE = /\{([a-z_]+)\}/g;

export const SYMBOL_TO_TOKEN = Object.fromEntries(
  Object.entries(ICONS).flatMap(([name, { replaces }]) => replaces.map((s) => [s, `{${name}}`])));
export const emojiToToken = (ch) => SYMBOL_TO_TOKEN[String(ch).replace(/\uFE0F/g, '')] ?? null;

// Variation selectors (U+FE0F) trail many emojis in source; a mapped symbol's selector goes with
// it (so does the text-style U+FE0E), an unmapped emoji keeps its own (without it ✏️ / 👁️ fall back to monochrome glyphs).
export function tokenize(str) {
  let out = String(str);
  for (const [sym, tok] of Object.entries(SYMBOL_TO_TOKEN)) out = out.split(sym + '\uFE0F').join(tok).split(sym + '\uFE0E').join(tok).split(sym).join(tok);
  return out;
}
